/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuTypeahead_viewer$ref = any;
export type SbSharedRefineMenuTypeaheadContainer_viewer$ref = any;
export type SbSharedRefineMenuTypeaheadContainer_viewer = {
    readonly isSearchWithinFilterEnabled: boolean | null;
    readonly " $fragmentRefs": SbSharedRefineMenuTypeahead_viewer$ref;
    readonly " $refType": SbSharedRefineMenuTypeaheadContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isSearchWithinFilterEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "REFINE_MENU_SEARCH"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuTypeahead_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'cdc32f46cd0d50c9dfad531b76e5bd14';
export default node;
